import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import Dropdown from "@cayuse/shared-react.components.dropdown";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import { useDictionary } from "hooks";
import { budgetBuilderSelectors } from "store/selectors";
import { changePeriodNumber } from "store/actions/budgetBuilder";
import { generatePeriodDropdownItems } from "utils/budgetBuilder";

import styles from "./styles.css";


const PeriodDropdown = ({ disabled = false }) => {
	const dictionary = useDictionary("budgetBuilder.components.PeriodDropdown");
	const { dateFormatter } = useTenantFormatter();
	const selectedPeriod = useSelector(budgetBuilderSelectors.currentPeriodNumber);
	const periodList = useSelector(budgetBuilderSelectors.periodRows);
	const dropdownOptions = useMemo(
		() => generatePeriodDropdownItems(
			periodList,
			dateFormatter,
			dictionary.periodOf || "Period {periodNumber} of {numberOfPeriods}"
		),
		[ dateFormatter, dictionary.periodOf, periodList ]
	);

	const handlePeriodChange = (e, { value }) => changePeriodNumber(value);

	return (
		<div className={styles.periodDropdownContainer}>
			<div className={styles.periodDropdownLabel}>
				<label>{dictionary.label || "Details for period"}</label>
			</div>
			<Dropdown
				className={styles.periodDropdown}
				selection
				options={dropdownOptions}
				onChange={handlePeriodChange}
				value={selectedPeriod}
				disabled={disabled}
			/>
		</div>
	);
};

export default PeriodDropdown;
